export default function GreenBars() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.219" height="15.375" viewBox="0 0 19.219 15.375">
      <g transform="translate(-604.395 -101.5)">
        <path
          d="M-12398.605-21067h19.219"
          transform="translate(13003 21176.188)"
          fill="none"
          stroke="#2ac0d5"
          strokeWidth="3"
        />
        <path
          d="M-12398.605-21067h9.609"
          transform="translate(13012.609 21182.375)"
          fill="none"
          stroke="#2ac0d5"
          strokeWidth="3"
        />
        <path
          d="M-12398.605-21067h9.609"
          transform="translate(13003 21170)"
          fill="none"
          stroke="#2ac0d5"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
}